/**
 * Roadkillレイヤ名型定義
 */
export type RoadkillLayerType = "ロードキル発生状況" | "ロードキル対策実施状況";

/**
 * Roadkillレイヤ詳細格納クラス
 */
export class RoadkillLayerName {
  /**
   * Roadkillレイヤ名
   */
  layerType: RoadkillLayerType;

  /**
   * Roadkill道路種別コード
   */
  id: string[];

  /**
   * 時間コード
   */
  timeCode: string[];

  /**
   * コンストラクタ
   * @param layerType
   * @param id
   * @param timeCode
   */
  constructor(layerType: RoadkillLayerType, id: string[], timeCode?: string[]) {
    this.layerType = layerType;
    this.id = id;
    this.timeCode = timeCode;
  }

  /**
   * Roadkillレイヤ物理名を取得する
   */
  getLayerName(): string {
    return this.layerType;
  }
}
